{
	"clientDetailsDialog": {
		"birthDate": "Date de naissance",
		"editClientData": "Modifier les données du client",
		"email": "Email",
		"name": "Nom",
		"phone": "Téléphone"
	},
	"inputs": {
		"searchPlaceholder": "Tapez pour effectuer une recherche"
	},
	"loginForm": {
		"login": "Connexion",
		"org": "Organisation",
		"password": "Mot de passe",
		"submit": "Entrer"
	},
	"multiEntranceInputRelation": {
		"addEntrance": "Ajouter une entrée",
		"removeEntrance": "Supprimer l'entrée"
	},
	"paymentRequestForm": {
		"account": "Compte",
		"accountPlaceholder": "Ex: 44440",
		"agency": "Agence",
		"agencyPlaceholder": "Ex: 5214",
		"alert": "Attention ! Les demandes effectuées après 10h30 ne seront traitées que le lendemain.",
		"alertAnticipation": "Attention ! Les demandes d'anticipation présentées jusqu'à 18h00 seront traitées le jour ouvrable suivant. Passé ce délai, les demandes seront traitées dans un délai de deux jours ouvrables.",
		"bank": "Banque",
		"bankData": "Doonées bancaires",
		"bankPlaceholder": "Sélectionner une banque",
		"buttonSolicitation": "Faire une demande",
		"checking": "Vérification du compte",
		"document": "CPF ou CNPJ",
		"documentPlaceholder": "Ex: 123456789",
		"reason": "Motif",
		"reasonPlaceholder": "Indiquer le motif de la transaction",
		"savings": "Compte d'épargne",
		"type": "Type",
		"useAnotherBankAccount": "Utiliser un compte bancaire standard ?",
		"value": "Montant"
	},
	"placeComboProductInput": {
		"filterProducts": "Filtrer produits"
	},
	"selects": {
		"newFiscalModeOptions": {
			"nfce": "NFC-e",
			"sat": "SAT-e"
		},
		"regimeTributarioOptions": {
			"regimeNormal": "Régime Normal",
			"simplesNacional": "Simples Nacional",
			"simplesNacionalExcesso": "Simples Nacional Excesso"
		},
		"states": {
			"AC": "Acre",
			"AL": "Alagoas",
			"AM": "Amapá",
			"BA": "Bahia",
			"CE": "Ceará",
			"DF": "Distrito Federal",
			"ES": "Espírito Santo",
			"GO": "Goiânia",
			"MA": "Maranhão",
			"MG": "Minas Gerais",
			"MS": "Mato Grosso do Sul",
			"MT": "Mato Grosso",
			"PA": "Pará",
			"PB": "Paraíba",
			"PE": "Pernambuco",
			"PI": "Piauí",
			"PR": "Paraná",
			"RJ": "Rio de Janeiro",
			"RN": "Rio Grande do Norte",
			"RO": "Rondônia",
			"RR": "Roraima",
			"RS": "Rio Grande do Sul",
			"SC": "Santa Catarina",
			"SE": "Sergipe",
			"SP": "São Paulo",
			"TO": "Tocantins"
		}
	},
	"validations": {
		"invalidEmail": "Adresse email invalide",
		"requiredField": "Ce champ est obligatoire",
		"requiredFieldShort": "Champ obligatoire"
	}
}
